var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import store from '../../../store';
import Errors from '../../../core/form/errors';
import FraimsyApi from '../../../core/api/fraimsy-api';
import { User } from '../../../models/user';
import { getUserToken, setAxiosDefaultHeaders } from '../../../core/helpers/axios';
import { CREATE_USER_ERROR, CREATE_USER_REQUEST, CREATE_USER_SUCCESS, FETCH_USER_ERROR, FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_UNAUTHORIZED, LOGIN_USER_ERROR, LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, RESET_USER_REQUEST, UPDATE_USER_DEFAULT_SHIPPING_ADDRESS_REQUEST, UPDATE_USER_ERROR, UPDATE_USER_PASSWORD_ERROR, UPDATE_USER_PASSWORD_REQUEST, UPDATE_USER_PASSWORD_SUCCESS, UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, } from './actionTypes';
export var requestResetPassword = function (email) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, FraimsyApi.post("password/email", { email: email })];
            case 1:
                response = _a.sent();
                if (200 !== response.status) {
                    throw new Error("validateResetPasswordToken response status is invalid " + response.status);
                }
                return [2 /*return*/, true];
            case 2:
                err_1 = _a.sent();
                Errors.createAndThrowFromException(err_1);
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var validateResetPasswordToken = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, FraimsyApi.post("password/reset/validate", data)];
            case 1:
                response = _a.sent();
                if (200 !== response.status) {
                    throw new Error("validateResetPasswordToken response status is invalid " + response.status);
                }
                return [2 /*return*/, true];
            case 2:
                err_2 = _a.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
export var resetUserPassword = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, FraimsyApi.post("password/reset", data)];
            case 1:
                response = _a.sent();
                if (200 !== response.status) {
                    throw new Error("resetUserPassword response status is invalid " + response.status);
                }
                return [2 /*return*/, true];
            case 2:
                err_3 = _a.sent();
                Errors.createAndThrowFromException(err_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, false];
        }
    });
}); }; };
export var fetchUser = function (force) {
    if (force === void 0) { force = false; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var state, userToken, response, item, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = store.getState();
                    if (!force && 'loaded' === state.auth.item.status) {
                        return [2 /*return*/, state.auth.item.item];
                    }
                    userToken = getUserToken();
                    if (!userToken) {
                        dispatch({ type: FETCH_USER_UNAUTHORIZED });
                        return [2 /*return*/];
                    }
                    dispatch({ type: FETCH_USER_REQUEST });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, FraimsyApi.get("user")];
                case 2:
                    response = _a.sent();
                    if (200 !== response.status) {
                        throw new Error("fetchUser response status is invalid " + response.status);
                    }
                    item = new User(__assign(__assign({}, response.data.data), { roles: __assign({}, response.data.data.roles) }));
                    dispatch({ type: FETCH_USER_SUCCESS, item: item });
                    return [2 /*return*/, item];
                case 3:
                    err_4 = _a.sent();
                    document.location.href = '/auth/logout';
                    if (401 === err_4.response.status) {
                        setAxiosDefaultHeaders();
                        dispatch({ type: FETCH_USER_UNAUTHORIZED });
                        return [2 /*return*/, null];
                    }
                    dispatch({ type: FETCH_USER_ERROR });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, null];
            }
        });
    }); };
};
export var updateUser = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: UPDATE_USER_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.put("user", data)];
            case 2:
                response = _a.sent();
                if (200 !== response.status) {
                    throw new Error("updateUser response status is invalid: " + response.status);
                }
                item = new User(response.data.data);
                dispatch({ type: UPDATE_USER_SUCCESS, item: item });
                return [2 /*return*/, item];
            case 3:
                err_5 = _a.sent();
                dispatch({ type: UPDATE_USER_ERROR });
                Errors.createAndThrowFromException(err_5);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
export var updateUserPassword = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: UPDATE_USER_PASSWORD_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.put("user/password", data)];
            case 2:
                response = _a.sent();
                if (200 !== response.status) {
                    throw new Error("updateUserPassword response status is invalid: " + response.status);
                }
                dispatch({ type: UPDATE_USER_PASSWORD_SUCCESS });
                return [2 /*return*/, true];
            case 3:
                err_6 = _a.sent();
                dispatch({ type: UPDATE_USER_PASSWORD_ERROR });
                Errors.createAndThrowFromException(err_6);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, false];
        }
    });
}); }; };
export var createUser = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: CREATE_USER_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.post("user", data)];
            case 2:
                response = _a.sent();
                if (201 !== response.status) {
                    throw new Error("createUser response status is invalid: " + response.status);
                }
                item = new User(response.data.data);
                dispatch({ type: CREATE_USER_SUCCESS, item: item });
                setAxiosDefaultHeaders();
                return [2 /*return*/, item];
            case 3:
                err_7 = _a.sent();
                dispatch({ type: CREATE_USER_ERROR });
                Errors.createAndThrowFromException(err_7);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
export var updateUserDefaultShippingAddress = function (item) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({ type: UPDATE_USER_DEFAULT_SHIPPING_ADDRESS_REQUEST, item: item });
        return [2 /*return*/];
    });
}); }; };
export var resetUser = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({ type: RESET_USER_REQUEST });
        return [2 /*return*/];
    });
}); }; };
export var loginUser = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, item, err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({ type: LOGIN_USER_REQUEST });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, FraimsyApi.post("login", data)];
            case 2:
                response = _a.sent();
                if (200 !== response.status) {
                    throw new Error("loginUser response status is invalid: " + response.status);
                }
                item = new User(response.data.data);
                dispatch({ type: LOGIN_USER_SUCCESS, item: item });
                setAxiosDefaultHeaders();
                return [2 /*return*/, item];
            case 3:
                err_8 = _a.sent();
                dispatch({ type: LOGIN_USER_ERROR });
                Errors.createAndThrowFromException(err_8);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
